import { render, staticRenderFns } from "./ECommerceProductDetailsItemFeatures.vue?vue&type=template&id=6e6a7a30"
import script from "./ECommerceProductDetailsItemFeatures.vue?vue&type=script&lang=js"
export * from "./ECommerceProductDetailsItemFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports